import { useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { omit } from 'ramda';

import { getURLParams } from '@core/js/utils/url.util';

import { QUERY_PARAMS } from './constants';

export const useQueryParam = (searchParam: QUERY_PARAMS, isShouldRemove = true) => {
    const history = useHistory();
    const { search } = useLocation();
    const params = getURLParams(search);
    const param = useRef(params?.[searchParam]);

    if (params?.[searchParam] && isShouldRemove) {
        history.replace({
            search: `?${new URLSearchParams(omit([searchParam], params)).toString()}`
        });
    }

    return param.current;
};
